import {useState, useRef, useEffect} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {ChevronBlackIcon} from '../icons/ChevronBlack';
import clsx from 'clsx';
import {
  useRefinementList,
  type UseRefinementListProps,
} from 'react-instantsearch';

export const FilterDropdown = (props: UseRefinementListProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);

  const {items, refine} = useRefinementList(props);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      className=" group relative flex flex-row  items-center"
    >
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="richH7 flex items-center gap-x-[6px]"
      >
        <span>Filter</span>
        <ChevronBlackIcon
          className={clsx([
            'transition-standard',
            isOpen ? 'rotate-180' : 'rotate-0',
          ])}
        />
      </button>
      <AnimatePresence mode="wait">
        <motion.div
          initial={{height: 0}}
          animate={isOpen ? {height: 'auto'} : {height: 0}}
          exit={{height: 0}}
          className={clsx(
            ' absolute right-0 top-3 z-10  mt-3 w-full min-w-[200px]  rounded bg-white shadow-2xl',
            {
              'border border-dark-grey': isOpen,
            },
          )}
        >
          <div className="my-1 h-full max-h-[300px] w-full overflow-y-auto overflow-x-hidden">
            {items?.map((item) => (
              <label className="flex cursor-pointer flex-row-reverse items-center justify-end gap-x-[10px] whitespace-normal  p-2 text-left font-bold text-sm">
                <input
                  type="checkbox"
                  className="hidden"
                  key={item.label}
                  checked={item.isRefined}
                  onChange={() => {
                    refine(item.value);
                  }}
                />
                <span>{item.label}</span>
                <div
                  className={clsx([
                    'transition-standard h-5 w-5 flex-shrink-0 rounded-full border',
                    item.isRefined
                      ? 'border-orange bg-orange'
                      : 'border-dark-grey/20 bg-white',
                  ])}
                />
              </label>
            ))}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
